var currentSearchTerm = new URLSearchParams(window.location.search).get('q');
initializeSwatchesOnAllCards();

function getLevenshteinDistance(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    const matrix = Array(b.length + 1).fill(null).map(() => Array(a.length + 1).fill(null));

    for (let i = 0; i <= a.length; i++) {
        matrix[0][i] = i;
    }
    for (let j = 0; j <= b.length; j++) {
        matrix[j][0] = j;
    }

    for (let j = 1; j <= b.length; j++) {
        for (let i = 1; i <= a.length; i++) {
            const substitutionCost = a[i - 1] === b[j - 1] ? 0 : 1;
            matrix[j][i] = Math.min(
                matrix[j][i - 1] + 1,                            // deletion
                matrix[j - 1][i] + 1,                            // insertion
                matrix[j - 1][i - 1] + substitutionCost         // substitution
            );
        }
    }
    return matrix[b.length][a.length];
}

  function attachOrRefreshGradientObserver() {
    //This is done every time the page 'refreshes', because the new HTML elements break old observers.
    console.log("Trying to attach observers for each card.");
  // Clean up previous observers first
  if (window.swatchObservers) {
    window.swatchObservers.forEach(observer => observer.disconnect());
  }
  window.swatchObservers = [];

  const productCards = Array.from(document.querySelectorAll('.product-card'));

  productCards.forEach(card => {
    const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Check if the node is a <variant-swatch-king> element
        if (node.nodeName.toLowerCase() === 'variant-swatch-king') {
          // Get the parent element
          const parent = node.parentElement.parentElement; // or node.parentNode
          this.swatchCallback(parent);
          // You can now return or use the parent as needed
        }
        // If <variant-swatch-king> might be nested inside added node
        else {
          const swatch = node.querySelector('variant-swatch-king');
          if (swatch) {
            const parent = swatch.parentElement; // or swatch.parentNode
            // Use the parent as needed
          }
        }
      }
    });
  });
});

    const cardInformation = card.querySelector('.card-information');
    if (cardInformation) {
      observer.observe(cardInformation, {
        childList: true,
        subtree: true // Crucial for nested elements
      });
      window.swatchObservers.push(observer);
    }
  });
};

  async function initializeSwatchesOnAllCards() {
  console.log('Checking all product cards simultaneously at 50ms intervals for variant-swatch-king.');
  const productCards = Array.from(document.querySelectorAll('.product-card'));

  // Start checking all cards simultaneously
  const promises = productCards.map(async (card) => {
    try {
      // This will check every 50ms as defined in waitForSelectorWithin
      const variantSwatchKing = await this.waitForSelectorWithin(card, 'variant-swatch-king', 5000);
      
      if (variantSwatchKing) {
        console.log('variant-swatch-king found in card:', card);
        const parent = variantSwatchKing.parentElement.parentElement;
        this.swatchCallback(parent);
        return { card, success: true };
      } else {
        console.log('variant-swatch-king not found in card within timeout:', card);
        return { card, success: false };
      }
    } catch (error) {
      console.error('Error processing card:', card, error);
      return { card, success: false, error };
    }
  });

  // Wait for all cards to complete
  const results = await Promise.all(promises);
  console.log('Finished checking all product cards:', results);
}

function waitForSelectorWithin(parent, selector, timeout = 2000) {
     //Called from swatchCallback. Required as swatch-king element takes time to load, so it checks until swatch-king exists.
  return new Promise((resolve, reject) => {
    const interval = 50;
    let elapsed = 0;
    function check() {
      const el = parent.querySelector(selector);
      if (el) return resolve(el);
      elapsed += interval;
      if (elapsed >= timeout) return resolve(null);
      setTimeout(check, interval);
    }
    check();
  });
}

function swatchCallback(swatchElement) {
    console.log("swatchCallback is executing.");
    const variantJsonElement = swatchElement.querySelector('#variant-json');

    if (variantJsonElement) {
        const jsonContent = variantJsonElement.textContent;
        const variantsData = JSON.parse(jsonContent);

        if (currentSearchTerm && variantsData && Array.isArray(variantsData.variants) && variantsData.variants.length > 0) {
            // Convert search term to lowercase once to reuse it
            const searchTermLower = currentSearchTerm.toLowerCase();
            const normalizedSearchTerm = searchTermLower.replace(/\s+/g, ''); // "WY 4269" -> "wy4269"
            const variants = variantsData.variants;
            let matchingIndex = -1;
            let matchType = '';


            // --- PRIORITY 0: Specific "Protak" Search Override ---
            if (searchTermLower === 'protak') {
                // Find the first variant where the 'protak' field is "Yes" (case-insensitive)
                matchingIndex = variants.findIndex(v => 
                    v.protak && v.protak.toString().toLowerCase() === 'yes'
                );
                
                if (matchingIndex !== -1) {
                    matchType = 'Protak Search Auto-Selection';
                }
            }


            // Priority 1: Improved SKU Match (Handles missing suffixes and spaces)
            if(matchingIndex === -1){
matchingIndex = variants.findIndex(v => {
    if (!v.sku) return false;
    const normalizedSku = v.sku.toLowerCase().replace(/\s+/g, ''); // "WY 4269X" -> "wy4269x"
    
    // Check for exact match or if the SKU starts with the search term (e.g., wy4269x starts with wy4269)
    return normalizedSku === normalizedSearchTerm || normalizedSku.startsWith(normalizedSearchTerm);
});

if (matchingIndex !== -1) matchType = 'Improved SKU Match';
            }

            
            // Priority 2: Perfect Title Match (already case-insensitive)
            if (matchingIndex === -1) {
                matchingIndex = variants.findIndex(v => v.title && v.title.toLowerCase() === searchTermLower);
                if (matchingIndex !== -1) matchType = 'Perfect Title Match';
            }
            
            // Priority 3: Partial/Code SKU Match (now case-insensitive)
            if (matchingIndex === -1) {
                matchingIndex = variants.findIndex(variant => {
                    if (typeof variant.sku !== 'string') return false;
                    const skuParts = variant.sku.split(' ');
                    if (skuParts.length > 1) {
                        // Convert the SKU code part to lowercase for comparison
                        const skuCode = skuParts[1].toLowerCase(); 

                        if (skuCode === searchTermLower) {
                            matchType = 'Exact Code Match'; return true;
                        }
                        if (skuCode.startsWith(searchTermLower)) {
                            matchType = 'Partial Code Match'; return true;
                        }
                    }
                    return false;
                });
            }

            // Priority 4: Levenshtein Distance on Title (already case-insensitive)
            if (matchingIndex === -1) {
                console.log("No exact match found. Calculating Levenshtein distance for titles...");
                let lowestDistance = Infinity;
                let bestMatchIndex = -1;

                variants.forEach((variant, index) => {
                    if (variant.title && typeof variant.title === 'string') {
                        const distance = getLevenshteinDistance(searchTermLower, variant.title.toLowerCase());
                        console.log(`   - Levenshtein distance for "${variant.title}": ${distance}`);
                        if (distance < lowestDistance) {
                            lowestDistance = distance;
                            bestMatchIndex = index;
                        }
                    }
                });

                if (bestMatchIndex !== -1 && lowestDistance < 5) {
                    matchingIndex = bestMatchIndex;
                    matchType = `Closest Title Match (Levenshtein Distance: ${lowestDistance})`;
                }
            }

            // --- FINAL RESULT PROCESSING AND CLICK ACTION ---
            if (matchingIndex !== -1) {
                const closestVariant = variants[matchingIndex];
                
                console.log(`✅ Match Found! (Reason: ${matchType})`);
                console.log("   - Matching Index:", matchingIndex);
                console.log("   - Matching Variant:", closestVariant);

                const productImageLink = swatchElement.querySelector('.card--product a.media');
                if (productImageLink) {
                    productImageLink.classList.add('matched-product-card');
                    console.log("Successfully applied final outline styles to the <a> tag.");
                } else {
                    console.error("Could not find '.card--product a.media' to apply outline.");
                }

                if (closestVariant && closestVariant.title) {
                    const selector = `div.swatch-selector[data-value="${CSS.escape(closestVariant.title)}"]`;
                    console.log(`Attempting to find and click element with selector: ${selector}`);
                    
                    waitForSelectorWithin(swatchElement, selector, 10000).then(targetElement => {
                        if (targetElement) {
                            targetElement.click();
                            console.log(`Successfully clicked the swatch for: ${closestVariant.title}`);
                        } else {
                            console.error(`Could not find the swatch element to click for variant: ${closestVariant.title}`);
                        }
                    });
                } else {
                    console.error("The matched variant does not have a valid title, cannot click.", closestVariant);
                }
            } else {
                console.log(`❌ No suitable match found for "${currentSearchTerm}" in this product.`);
            }
        }
    }
}